module.exports = __webpack_public_path__ + "img/portrait-027.fe3ef379.jpg";